import styled from 'styled-components';

export const AssetNetworkWrapper = styled.div`
  position: relative;
`;

type IconProps = {
  size: string | number;
};
export const AssetIcon = styled.img<IconProps>`
  width: ${({ size }) => `${size}rem`};
  height: ${({ size }) => `${size}rem`};
`;

export const NetworkIcon = styled.img<IconProps>`
  width: ${({ size }) => `${size}rem`};
  height: ${({ size }) => `${size}rem`};
  position: absolute;
  bottom: 0;
  right: 0;
`;
